import React from 'react';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import Modal from '../../../components/modals';
import validator from 'validator';
import { withRouter } from '../../../../services/withRoute';
import InputHeader from '../../global/inputwithHeader';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/Project/close.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import _ from 'lodash';

class InviteUser extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			emailError: false,
			emailErrorMessage: '',
			isMember: false,
		};
	}

	timer = null;

	componentWillUnmount = () => {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	};

	renderAlreadyMember = () => {
		return (
			<div className="invite-user-modal-container">
				<div className="invite-user-header">
					<span className="title">SEND INVITE TO {this.state.email}</span>
					<span className="close-icn" onClick={() => this.props.close()}>
						<CloseIcon />
					</span>
				</div>
				<div className="invite-user-body" style={{ alignItems: 'center' }}>
					{this.state.email} is already added to your workspace as a Member.
				</div>
				<div className="invite-user-footer" style={{ justifyContent: 'center' }}>
					<span
						className="okay-btn"
						onClick={() =>
							this.setState({
								isMember: false,
								email: '',
								emailError: false,
								emailErrorMessage: '',
							})
						}
					>
						Okay, Got it
					</span>
				</div>
			</div>
		);
	};

	isDisabled = () => {
		if (
			this.state.email !== '' &&
			this.state.email !== null &&
			validator.isEmail(this.state.email) &&
			this.state.emailError === false &&
			_.findIndex(this.props.userList, {
				email: this.state.email.trim().toLowerCase(),
			}) === -1
		) {
			return false;
		} else {
			return true;
		}
	};

	handleInputChange = (e) => {
		clearTimeout(this.timer);

		let value = e.target.value;

		this.setState({
			email: value,
		});
		setTimeout(() => {
			if (value === '') {
				this.setState({
					emailError: true,
					emailErrorMessage: 'Email is required!',
				});
			} else if (!validator.isEmail(this.state.email)) {
				this.setState({
					emailError: true,
					emailErrorMessage: 'Please enter correct email',
				});
			} else if (validator.isEmail(this.state.email)) {
				this.setState({
					emailError: false,
					emailErrorMessage: '',
				});

				if (
					_.find(this.props.userList, {
						email: this.state.email.trim().toLowerCase(),
					})
				) {
					this.setState({
						isMember: true,
					});
				} else {
					this.setState({
						isMember: false,
					});
				}
			}
		}, 300);
	};

	renderInviteUser = () => {
		return (
			<div className="invite-user-modal-container">
				<div className="invite-user-header">
					<span className="title">SEND INVITE</span>
					<span className="close-icn" onClick={() => this.props.close()}>
						<CloseIcon />
					</span>
				</div>
				<div className="invite-user-body" style={{ paddingTop: '48px' }}>
					<InputHeader
						type="text"
						name="email"
						isInputError={this.state.emailError}
						label="Email"
						value={this.state.email}
						onChange={(e) => {
							this.handleInputChange(e);
						}}
						errorMessage={this.state.emailErrorMessage}
						width="100%"
						marginBottom="0px"
						required={true}
					/>
				</div>
				<div className="invite-user-footer">
					<span
						className={
							'submit-btn-disabled' + (this.isDisabled() === false ? ' enabled' : '')
						}
						onClick={() =>
							this.isDisabled() === false &&
							this.props.handleInviteUser(this.state.email)
						}
					>
						<span className="plus-icn">
							<PlusIcon />
						</span>
						Send Invite
					</span>
				</div>
			</div>
		);
	};

	render() {
		return (
			<Modal
				handleClose={() => this.props.close()}
				show={this.props.show}
				modalType={'center'}
			>
				{this.state.isMember ? this.renderAlreadyMember() : this.renderInviteUser()}
			</Modal>
		);
	}
}

export default withRouter(InviteUser);
